import { render, staticRenderFns } from "./CustomerTrainingTimeProgessionCard.vue?vue&type=template&id=35491b90&"
import script from "./CustomerTrainingTimeProgessionCard.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingTimeProgessionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports